export default "__VITE_ASSET__C1jK_jtC__"